"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// Sidebar.tsx in ui-library
var react_1 = __importStar(require("react"));
var antd_1 = require("antd");
require("./Sidebar.css");
// Define inline SVG icon components
var ProfileDarkIcon = function (props) { return (react_1.default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "19.135", height: "23.279", viewBox: "0 0 19.135 23.279" }, props),
    react_1.default.createElement("g", { id: "Group_38421", "data-name": "Group 38421", transform: "translate(-2.41 -1)" },
        react_1.default.createElement("path", { id: "Path_38072", "data-name": "Path 38072", d: "M11.986,12.722a5.736,5.736,0,1,1,5.736-5.736A5.743,5.743,0,0,1,11.986,12.722Zm0-9.976a4.24,4.24,0,1,0,4.24,4.24A4.249,4.249,0,0,0,11.986,2.746Z", transform: "translate(-0.009)", fill: "#fff", stroke: "#fff", strokeWidth: "0.5" }),
        react_1.default.createElement("path", { id: "Path_38073", "data-name": "Path 38073", d: "M20.547,22.73a.754.754,0,0,1-.748-.748c0-3.442-3.511-6.235-7.821-6.235S4.157,18.54,4.157,21.981a.748.748,0,0,1-1.5,0c0-4.26,4.18-7.731,9.318-7.731S21.3,17.722,21.3,21.981A.754.754,0,0,1,20.547,22.73Z", transform: "translate(0 1.3)", fill: "#fff", stroke: "#fff", strokeWidth: "0.5" })))); };
var ProfileLightIcon = function (props) { return (react_1.default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "19.135", height: "23.279", viewBox: "0 0 19.135 23.279" }, props),
    react_1.default.createElement("g", { id: "Group_38421", "data-name": "Group 38421", transform: "translate(-2.41 -1)" },
        react_1.default.createElement("path", { id: "Path_38072", "data-name": "Path 38072", d: "M11.986,12.722a5.736,5.736,0,1,1,5.736-5.736A5.743,5.743,0,0,1,11.986,12.722Zm0-9.976a4.24,4.24,0,1,0,4.24,4.24A4.249,4.249,0,0,0,11.986,2.746Z", transform: "translate(-0.009)", stroke: "#000", strokeWidth: "0.5" }),
        react_1.default.createElement("path", { id: "Path_38073", "data-name": "Path 38073", d: "M20.547,22.73a.754.754,0,0,1-.748-.748c0-3.442-3.511-6.235-7.821-6.235S4.157,18.54,4.157,21.981a.748.748,0,0,1-1.5,0c0-4.26,4.18-7.731,9.318-7.731S21.3,17.722,21.3,21.981A.754.754,0,0,1,20.547,22.73Z", transform: "translate(0 1.3)", stroke: "#000", strokeWidth: "0.5" })))); };
var ThemeDarkIcon = function (props) { return (react_1.default.createElement("svg", __assign({ id: "Group_38422", "data-name": "Group 38422", xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props),
    react_1.default.createElement("path", { id: "Path_38074", "data-name": "Path 38074", d: "M118.75,125.5a6.75,6.75,0,1,1,6.75-6.75A6.758,6.758,0,0,1,118.75,125.5Zm0-12a5.25,5.25,0,1,0,5.25,5.25A5.256,5.256,0,0,0,118.75,113.5Z", transform: "translate(-106.75 -106.75)", fill: "#fff" }),
    react_1.default.createElement("path", { id: "Path_38075", "data-name": "Path 38075", d: "M240.75,3.75A.75.75,0,0,1,240,3V.75a.75.75,0,0,1,1.5,0V3A.75.75,0,0,1,240.75,3.75Z", transform: "translate(-228.75)", fill: "#fff" }),
    react_1.default.createElement("path", { id: "Path_38076", "data-name": "Path 38076", d: "M240.75,435.75A.75.75,0,0,1,240,435v-2.25a.75.75,0,0,1,1.5,0V435A.75.75,0,0,1,240.75,435.75Z", transform: "translate(-228.75 -411.75)", fill: "#fff" }),
    react_1.default.createElement("path", { id: "Path_38077", "data-name": "Path 38077", d: "M435,241.5h-2.25a.75.75,0,0,1,0-1.5H435a.75.75,0,0,1,0,1.5Z", transform: "translate(-411.75 -228.75)", fill: "#fff" }),
    react_1.default.createElement("path", { id: "Path_38078", "data-name": "Path 38078", d: "M3,241.5H.75a.75.75,0,0,1,0-1.5H3a.75.75,0,0,1,0,1.5Z", transform: "translate(0 -228.75)", fill: "#fff" }),
    react_1.default.createElement("path", { id: "Path_38079", "data-name": "Path 38079", d: "M376.5,73.385a.751.751,0,0,1-.53-1.28l1.591-1.591a.75.75,0,0,1,1.061,1.061l-1.591,1.591A.748.748,0,0,1,376.5,73.385Z", transform: "translate(-358.134 -66.999)", fill: "#fff" }),
    react_1.default.createElement("path", { id: "Path_38080", "data-name": "Path 38080", d: "M71.027,378.856a.751.751,0,0,1-.53-1.28l1.591-1.591a.75.75,0,0,1,1.061,1.061l-1.591,1.591A.748.748,0,0,1,71.027,378.856Z", transform: "translate(-66.982 -358.151)", fill: "#fff" }),
    react_1.default.createElement("path", { id: "Path_38081", "data-name": "Path 38081", d: "M378.106,378.856a.748.748,0,0,1-.53-.22l-1.591-1.591a.75.75,0,1,1,1.061-1.061l1.591,1.591a.751.751,0,0,1-.53,1.28Z", transform: "translate(-358.151 -358.151)", fill: "#fff" }),
    react_1.default.createElement("path", { id: "Path_38082", "data-name": "Path 38082", d: "M72.634,73.385a.748.748,0,0,1-.53-.22l-1.591-1.591a.75.75,0,0,1,1.061-1.061L73.165,72.1A.751.751,0,0,1,72.634,73.385Z", transform: "translate(-66.998 -66.999)", fill: "#fff" }))); };
var ThemeLightIcon = function (props) { return (react_1.default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "22.741", height: "22.743", viewBox: "0 0 22.741 22.743" }, props),
    react_1.default.createElement("g", { id: "Group_38509", "data-name": "Group 38509", transform: "translate(-0.75 -0.732)" },
        react_1.default.createElement("path", { id: "Path_38108", "data-name": "Path 38108", d: "M22.85,15.879a.36.36,0,0,0-.429-.029A10.158,10.158,0,0,1,8.375,1.8a.358.358,0,0,0-.449-.521A11.35,11.35,0,1,0,22.943,16.3.359.359,0,0,0,22.85,15.879ZM12.6,22.258A10.633,10.633,0,0,1,7.16,2.488A10.877,10.877,0,0,0,21.736,17.064,10.659,10.659,0,0,1,12.6,22.258Z", stroke: "#000", strokeWidth: "1" })))); };
var LogoutDarkIcon = function (props) { return (react_1.default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "20.676", height: "20.677", viewBox: "0 0 20.676 20.677" }, props),
    react_1.default.createElement("path", { id: "Path_38083", "data-name": "Path 38083", d: "M15.079,15.831v1.615a3.234,3.234,0,0,1-3.231,3.231H3.731A3.234,3.234,0,0,1,.5,17.446V3.231A3.234,3.234,0,0,1,3.731,0h8.117a3.234,3.234,0,0,1,3.231,3.231V4.846a.808.808,0,0,1-1.615,0V3.231a1.617,1.617,0,0,0-1.615-1.615H3.731A1.617,1.617,0,0,0,2.115,3.231V17.446a1.617,1.617,0,0,0,1.615,1.615h8.117a1.617,1.617,0,0,0,1.615-1.615V15.831a.808.808,0,1,1,1.615,0Zm5.507-6.88L18.777,7.142a.808.808,0,0,0-1.142,1.142l1.286,1.287h-9.7a.808.808,0,0,0,0,1.615h9.7l-1.286,1.287a.808.808,0,1,0,1.142,1.142l1.809-1.809A2.021,2.021,0,0,0,20.585,8.951Zm0,0", transform: "translate(-0.5)", fill: "#fff" }))); };
var LogoutLightIcon = function (props) { return (react_1.default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "20.676", height: "20.677", viewBox: "0 0 20.676 20.677" }, props),
    react_1.default.createElement("path", { id: "Path_38083", "data-name": "Path 38083", d: "M15.079,15.831v1.615a3.234,3.234,0,0,1-3.231,3.231H3.731A3.234,3.234,0,0,1,.5,17.446V3.231A3.234,3.234,0,0,1,3.731,0h8.117a3.234,3.234,0,0,1,3.231,3.231V4.846a.808.808,0,0,1-1.615,0V3.231a1.617,1.617,0,0,0-1.615-1.615H3.731A1.617,1.617,0,0,0,2.115,3.231V17.446a1.617,1.617,0,0,0,1.615,1.615h8.117a1.617,1.617,0,0,0,1.615-1.615V15.831a.808.808,0,1,1,1.615,0Zm5.507-6.88L18.777,7.142a.808.808,0,0,0-1.142,1.142l1.286,1.287h-9.7a.808.808,0,0,0,0,1.615h9.7l-1.286,1.287a.808.808,0,1,0,1.142,1.142l1.809-1.809A2.021,2.021,0,0,0,20.585,8.951Zm0,0", transform: "translate(-0.5)" }))); };
var Sidebar = function (_a) {
    var handleLogout = _a.handleLogout, menuItems = _a.menuItems, selectMenu = _a.selectMenu, themeMode = _a.themeMode, navigate = _a.navigate, location = _a.location, toggleTheme = _a.toggleTheme, _b = _a.userName, userName = _b === void 0 ? "Profile Name" : _b, userAvatar = _a.userAvatar, onProfileClick = _a.onProfileClick;
    var _c = (0, react_1.useState)(false), isDarkHover = _c[0], setIsDarkHover = _c[1];
    var _d = (0, react_1.useState)(false), isProfileDropdownOpen = _d[0], setIsProfileDropdownOpen = _d[1];
    var sidebarRef = (0, react_1.useRef)(null);
    var profileDropdownRef = (0, react_1.useRef)(null);
    // Only allow sidebar to close on mouse leave if profile menu is NOT open
    var handleSidebarMouseLeave = function () {
        if (!isProfileDropdownOpen)
            setIsDarkHover(false);
    };
    // Handle outside click for profile dropdown
    (0, react_1.useEffect)(function () {
        if (!isProfileDropdownOpen)
            return;
        function handleClickOutside(event) {
            if (sidebarRef.current &&
                !sidebarRef.current.contains(event.target)) {
                setIsProfileDropdownOpen(false);
                setIsDarkHover(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isProfileDropdownOpen]);
    // Select correct icon components based on themeMode
    var ProfileIconToRender = themeMode === "dark" ? ProfileDarkIcon : ProfileLightIcon;
    var ThemeIconToRender = themeMode === "dark" ? ThemeDarkIcon : ThemeLightIcon;
    var LogoutIconToRender = themeMode === "dark" ? LogoutDarkIcon : LogoutLightIcon;
    // Function to navigate to a selected route and select the menu
    var navigateTo = function (route, menu) {
        navigate(route);
        selectMenu(menu); // Update the selected menu using the provided function
    };
    // Render the logo based on the theme
    var getLogo = function () {
        var logoImage = themeMode === "dark"
            ? "/icons/loading-icon.gif"
            : "/icons/loading-icon-light.gif";
        return react_1.default.createElement("img", { src: logoImage, width: "50", alt: "Logo" });
    };
    // Render the text logo based on the theme
    var getTextLogo = function () {
        var textImage = themeMode === "dark" ? "/logo/dark-text.png" : "/logo/white-text.png";
        return react_1.default.createElement("img", { src: textImage, width: "150rem", height: "22px", style: { marginTop: "13px", marginLeft: "9px" }, alt: "Logo" });
        // return (
        //   <img
        //     src={textImage}
        //     width="150rem"
        //     height="1.375rem"
        //     alt="Logo"
        //     style={{
        //       marginTop: "0.8125rem",
        //       marginLeft: "0.5625rem"
        //     }}
        //   />
        // );
    };
    // Define styles based on the theme
    var mainBackgroundColor = themeMode === "dark" ? "#04002b" : "#f7f7f7";
    var textColor = themeMode === "dark" ? "#fff" : "#000";
    var borderRightColor = themeMode === "dark" ? "#151138" : "#E3E2E5";
    return (react_1.default.createElement("div", { ref: sidebarRef, role: "navigation", className: "sidebar-root ".concat(isDarkHover ? "expanded" : "collapsed"), style: {
            backgroundColor: mainBackgroundColor,
            color: textColor,
            borderRight: "1px solid ".concat(borderRightColor),
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            position: "relative",
        }, onMouseLeave: handleSidebarMouseLeave, onMouseEnter: function () { return setIsDarkHover(true); } },
        react_1.default.createElement("div", { style: { display: "flex", height: "3rem", padding: "1rem" } },
            getLogo(),
            isDarkHover ? getTextLogo() : null),
        react_1.default.createElement("div", { className: "sidebar-menu-items", style: { flex: 1 } }, menuItems.map(function (item, index) { return (react_1.default.createElement("div", { key: index, style: {
                width: isDarkHover ? "15rem" : "auto",
                textAlign: "center",
            } },
            react_1.default.createElement("div", { className: location.pathname === item.path
                    ? "sidebar-active-menu"
                    : "sidebar-in-active-menu", onClick: function () { return navigateTo(item.path, item.name); }, style: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "left",
                } },
                react_1.default.createElement("img", { className: "sidebar-home-icon", src: location.pathname !== item.path && themeMode === "light"
                        ? "/icons/menu-item-icons/light-theme/".concat(item.icon || "HOME", ".png")
                        : "/icons/menu-item-icons/dark-theme/".concat(item.icon || "HOME", ".png"), alt: "".concat(item.name, " icon") }),
                react_1.default.createElement("span", { style: {
                        display: isDarkHover ? "inline" : "none",
                        marginLeft: "1rem",
                    } }, item.name)))); })),
        react_1.default.createElement("div", { style: {
                position: "relative",
                width: "100%",
                marginBottom: "1rem",
            } },
            isProfileDropdownOpen && (react_1.default.createElement("div", { ref: profileDropdownRef, style: {
                    position: "absolute",
                    bottom: "10px",
                    left: "100%",
                    marginLeft: "10px",
                    backgroundColor: themeMode === "dark" ? "#3a3859" : "#f5f5f5",
                    borderRadius: "12px",
                    padding: "0.5rem",
                    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
                    zIndex: 9999,
                    minWidth: "200px",
                    whiteSpace: "nowrap",
                    border: "1px solid " + (themeMode === "dark" ? "#4a4869" : "#e0e0e0"),
                } },
                react_1.default.createElement("div", { onClick: function () {
                        onProfileClick && onProfileClick();
                        setIsProfileDropdownOpen(false);
                    }, style: {
                        display: "flex",
                        alignItems: "center",
                        padding: "0.75rem",
                        cursor: "pointer",
                        borderRadius: "6px",
                        marginBottom: "0.25rem",
                        transition: "background-color 0.2s",
                    }, onMouseEnter: function (e) {
                        e.currentTarget.style.backgroundColor =
                            themeMode === "dark" ? "#4a4869" : "#e0e0e0";
                    }, onMouseLeave: function (e) {
                        e.currentTarget.style.backgroundColor = "transparent";
                    } },
                    react_1.default.createElement(ProfileIconToRender, { style: {
                            width: "20px",
                            height: "20px",
                            marginRight: "0.75rem",
                        } }),
                    react_1.default.createElement("span", null, "Profile")),
                toggleTheme && (react_1.default.createElement("div", { style: {
                        display: "flex",
                        alignItems: "center",
                        padding: "0.75rem",
                        cursor: "pointer",
                        borderRadius: "6px",
                        marginBottom: "0.25rem",
                        transition: "background-color 0.2s",
                    }, onMouseEnter: function (e) {
                        e.currentTarget.style.backgroundColor =
                            themeMode === "dark" ? "#4a4869" : "#e0e0e0";
                    }, onMouseLeave: function (e) {
                        e.currentTarget.style.backgroundColor = "transparent";
                    } },
                    react_1.default.createElement(ThemeIconToRender, { style: {
                            width: "20px",
                            height: "20px",
                            marginRight: "0.75rem",
                        } }),
                    react_1.default.createElement("span", { style: { flex: 1 } }, "Theme"),
                    react_1.default.createElement(antd_1.Switch, { checked: themeMode === "dark", onChange: toggleTheme, size: "small" }))),
                react_1.default.createElement("div", { onClick: function () {
                        handleLogout();
                        setIsProfileDropdownOpen(false);
                    }, style: {
                        display: "flex",
                        alignItems: "center",
                        padding: "0.75rem",
                        cursor: "pointer",
                        borderRadius: "6px",
                        transition: "background-color 0.2s",
                    }, onMouseEnter: function (e) {
                        e.currentTarget.style.backgroundColor =
                            themeMode === "dark" ? "#4a4869" : "#e0e0e0";
                    }, onMouseLeave: function (e) {
                        e.currentTarget.style.backgroundColor = "transparent";
                    } },
                    react_1.default.createElement(LogoutIconToRender, { style: {
                            width: "20px",
                            height: "20px",
                            marginRight: "0.75rem",
                        } }),
                    react_1.default.createElement("span", null, "Logout")))),
            react_1.default.createElement("div", { onClick: function () {
                    setIsProfileDropdownOpen(function (open) { return !open; });
                    if (!isProfileDropdownOpen)
                        setIsDarkHover(true); // Ensure sidebar is open when opening profile
                }, style: {
                    display: "flex",
                    alignItems: "center",
                    padding: isDarkHover ? "0.75rem" : "0.5rem",
                    margin: "0 0.5rem",
                    backgroundColor: themeMode === "dark" ? "#3a3859" : "#f0f0f0",
                    borderRadius: "12px",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                } },
                react_1.default.createElement("div", { style: {
                        width: "40px",
                        height: "40px",
                        borderRadius: "8px",
                        backgroundColor: "#ff4e3a",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "white",
                        fontWeight: "600",
                        fontSize: "1.2rem",
                        marginRight: isDarkHover ? "0.75rem" : "0",
                        backgroundImage: userAvatar ? "url(".concat(userAvatar, ")") : undefined,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                    } }, !userAvatar && userName.charAt(0).toUpperCase()),
                isDarkHover && (react_1.default.createElement("div", { style: { display: "flex", alignItems: "center", flex: 1 } },
                    react_1.default.createElement("span", { style: { flex: 1, fontWeight: "500" } }, userName),
                    react_1.default.createElement("span", { style: { marginLeft: "0.5rem", fontSize: "1.2rem" } }, "\u203A")))))));
};
exports.default = Sidebar;
